import { FULL_INGESTION_LOG_NAME } from '../constants/ingestion.constants';
import { ILogSummaryItem } from '../constants/ingestionLog.interface';
import { INGESTION_CONSTANTS } from './Ingestion.constants';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';

export type ValidLogsType = {
  validLogs: Map<string, ILogSummaryItem>;
  currentSummary: Record<string, number>;
};

export const getValidLogs = (
  logs: ILogSummaryItem[] | undefined,
  dataSourceList: Record<'used' | 'unUsed', IDataSourceItem[]> | undefined
): ValidLogsType => {
  const validLogs = new Map();
  const currentSummary: Record<string, number> = {
    ingestionRunningCount: 0,
    ingestionSuccessCount: 0,
    ingestionErrorCount: 0,
    ingestionWarningCount: 0,
    ingestionStoppedCount: 0,
  };
  if (!logs || logs.length === 0 || !dataSourceList) {
    return { validLogs, currentSummary };
  }
  const usedDataSourceList = new Set(dataSourceList.used.map((item) => item.name));

  for (const log of logs) {
    const dataSourceName = log.dataSourceName;
    // Ensure the log's dataSourceName exists and that it is in the usedDataSourceList
    if (
      !dataSourceName ||
      (!usedDataSourceList.has(dataSourceName) && log.dataSourceName !== FULL_INGESTION_LOG_NAME)
    ) {
      continue;
    }

    // Skip logs that are in the list, since we only want the most recent
    // Note the list is ordered based on the start time, which the Backend guarantees so we can safely assume the first occurrence is the most recent.
    if (!validLogs.has(dataSourceName)) {
      validLogs.set(log.dataSourceName, { ...log });

      // Update the current summary
      switch (log.status) {
        case INGESTION_CONSTANTS.RUNNING:
        case INGESTION_CONSTANTS.TRIGGERED_STOP:
          currentSummary.ingestionRunningCount += 1;
          break;
        case INGESTION_CONSTANTS.SUCCESS:
          currentSummary.ingestionSuccessCount += 1;
          break;
        case INGESTION_CONSTANTS.ERROR:
        case INGESTION_CONSTANTS.CRASHED:
          currentSummary.ingestionErrorCount += 1;
          break;
        case INGESTION_CONSTANTS.WARNING:
          currentSummary.ingestionWarningCount += 1;
          break;
        case INGESTION_CONSTANTS.STOPPED:
          currentSummary.ingestionStoppedCount += 1;
          break;
        default:
          // If the status is not recognized, we can skip it or handle it as needed
          continue;
      }
    }
  }
  return { validLogs, currentSummary };
};
